module.exports = __webpack_public_path__ + "media/tape-nav/commerce-icon-c6e74fff.svg";